var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.networkLoading)?_c('div',{staticClass:"network_loading"},[_c('div',[_c('Spinner',{staticClass:"spinner"}),_c('p',[_vm._v(_vm._s(_vm.$t('network.blocker.desc')))])],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }